import { useEffect, useState } from "react";
import { motion } from "framer-motion";

function OfertBannerSection() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 640); // Umbral de 640px para dispositivos móviles
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
   <div className={`relative overflow-hidden ${isMobile ? "h-[70vh]" : "h-screen overflow-unseth"}`}>
      {/* Imagen con animación y sin desenfoque */}
      <motion.div
        className={`absolute top-0 left-0 w-full h-full ${
          isMobile ? "bg-cover bg-top" : "bg-cover bg-center"
        }`}
        style={{
          backgroundImage: `url(${
            isMobile ? "/post2-instagram.webp" : "/post2-web.webp"
          })`,
          filter: "brightness(1) contrast(1.2)", // Mejorar brillo y contraste
        }}
        initial={{ y: "0%" }}
      />

      {/* Capa oscura con opacidad controlada para mejorar la visibilidad de la imagen */}
      <div className="absolute inset-0 bg-black/30"></div>
    </div>
  );
}

export default OfertBannerSection;
